<!-- src/components/yuyue/modals/AppointmentDetailView.vue -->
<template>
    <div v-if="isVisible " class="modal" :class="{ active: isVisible }" @click.self="closeModal">
        <div class="modal-content">
            <span class="close-modal" @click="closeModal">&times;</span>
            <h2 class="modal-title">{{ appointmentType === 'edu' ? '教育产品' : '音疗预约' }}申请详情</h2>

            <div class="application-details">
                <div class="details-container">
                    <!-- 左侧：基本信息 -->
                    <div class="details-column">
                        <div class="detail-section">
                            <h3>基本信息</h3>
                            <div class="detail-row">
                                <span class="label">姓名:</span>
                                <span class="value">{{ appointmentData.name }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="label">{{this.appointmentType === 'edu'?'学校':'公司'}}/机构:</span>
                                <span class="value">{{ appointmentData.organization}}</span>
                            </div>
                            <div class="detail-row" v-if="this.appointmentType === 'edu'">
                                <span class="label">职位:</span>
                                <span class="value">{{ getPositionText(appointmentData.position) }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="label">联系电话:</span>
                                <span class="value">{{ appointmentData.phone }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="label">电子邮箱:</span>
                                <span class="value">{{ appointmentData.email }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="label">申请时间:</span>
                                <span class="value">{{ formatSubmitTime(appointmentData.submit_time) }}</span>
                            </div>
                        </div>

                        <div class="detail-section">
                            <h3>申请信息</h3>
                            <div class="detail-row">
                                <span class="label">感兴趣模块:</span>
                                <span class="value">{{ getInterestText(appointmentData.interest) }}</span>
                            </div>
                            <div class="detail-row">
                                <span class="label">当前状态:</span>
                                <span class="value">
                                    <span :class="['status-badge', appointmentData.state]">
                                        {{ getStatusText(appointmentData.state) }}
                                    </span>
                                </span>
                            </div>

                            <div class="detail-row" v-if="appointmentData.other">
                                <span class="label">其他需求:</span>
                                <span class="value">{{ appointmentData.other }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧：状态更新和备注 -->
                    <div class="details-column">
                        <div class="detail-section">
                            <h3>更新状态</h3>
                            <div class="form-group">
                                <label for="status">选择新状态:</label>
                                <select id="status"
                                        v-model="formData.state"
                                        class="status-select">
                                    <option value="create">待处理</option>
                                    <option value="contacted">已联系</option>
                                    <option value="rejected">已拒绝</option>
                                </select>
                            </div>
                        </div>

                        <div class="detail-section">
                            <h3>备注信息</h3>
                            <div class="form-group">
                                <label for="remarks">添加备注:</label>
                                <textarea id="remarks"
                                          v-model="formData.remarks"
                                          class="remarks-textarea"
                                          rows="6"
                                          placeholder="请输入备注信息..."></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <button @click="closeModal" class="btn btn-secondary">取消</button>
                    <button @click="updateAppointment" class="btn btn-primary" :disabled="isUpdating">
                        {{ isUpdating ? '更新中...' : '更新状态' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'AppointmentDetailView',
        props: {
            isVisible: {
                type: Boolean,
                default: false
            },
            appointmentData: {
                type: Object,
                default: () => ({})
            },
            appointmentType: {
                type: String,
                default: 'edu' // 'edu' 或 'sound'
            }
        },
        data() {
            return {
                isUpdating: false,
                formData: {
                    status: '',
                    remarks: ''
                }
            }
        },
        watch: {
            isVisible(newVal) {
                if (newVal) {
                    // 当对话框打开时，初始化表单数据
                    this.initializeFormData();
                }
            }
        },
        methods: {
            closeModal() {
                this.$emit('close');
            },
            initializeFormData() {
                this.formData.state = this.appointmentData.state;
                this.formData.remarks = this.appointmentData.handle_tip || '';
            },
            getPositionText(position) {
                const positionMap = {
                    'teacher': '教师',
                    'psychologist': '心理老师',
                    'administrator': '学校管理者',
                    'parent': '家长',
                    'other': '其他'
                };
                return positionMap[position] || position;
            },
            getInterestText(intest) {

              if (!intest || intest.length == 0) {
                  return "";
              }
              let interestMap = {};
              const intestList = intest.split(",");
                if (this.appointmentType === 'edu') {
                        interestMap = {
                        'teacher': '教师功能',
                        'student': '学生功能',
                        'parent': '家长功能',
                        'all': '全部功能'
                    };
                } else {
                    interestMap = {
                        'other': '其他场景',
                        'personal': '个人家庭',
                        'hotel': '高端酒店',
                        'medical': '医疗辅助',
                        'company': '企业健康',
                        'all': '所有场景'
                    };
                }
                const translatedList = intestList.map(item => {
                    const trimmedItem = item.trim();
                    return interestMap[trimmedItem] || trimmedItem;
                });

                return translatedList.join("  ") || intest;
            },
            getStatusText(status) {
                const statusMap = {
                    'create': '待处理',
                    'rejected': '已拒绝',
                    'contacted': '已联系',
                };
                return statusMap[status] || status;
            },
            formatSubmitTime(timestamp) {
                if (!timestamp) return '';
                const date = new Date(timestamp);
                return date.toLocaleString('zh-CN');
            },
           async updateAppointment() {
                this.isUpdating = true;
                const isInExpired = await this.$store.dispatch('isInExpired');
                if (!isInExpired) {
                    this.$message({
                        message: "登录已过期，请重新登录",
                        type: "error",
                    });
                    return;
                }

                const token = localStorage.getItem('token');
                try {
                    const payload = {
                        id:this.appointmentData.id,
                        state: this.formData.state,
                        handle_tip:this.formData.remarks,
                    };
                    const response = await axios.post('/api/reservation/update', payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: response.data.message,
                            type: "error",
                        });
                        return;
                    }

                    this.$message({
                        message: response.data.message,
                        type: response.data.type,
                    });
                    this.$emit('appointment-updated');

                    this.closeModal();
                } catch (error) {
                    console.error('summary failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                } finally {
                    this.isUpdating = false;
                }

            }
        }
    }
</script>

<style scoped>
    .modal {
        display: none;
        position: fixed;
        z-index: 1000;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        transition: opacity 0.3s ease;
    }

        .modal.active {
            display: block;
        }

    .modal-content {
        background-color: #fff;
        margin: 3% auto;
        padding: 30px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        width: 90%;
        max-width: 800px;
        position: relative;
        animation: modalopen 0.3s;
        max-height: 90vh;
        overflow-y: auto;
    }

    @keyframes modalopen {
        from {
            opacity: 0;
            transform: translateY(-60px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .close-modal {
        color: #aaa;
        float: right;
        font-size: 28px;
        font-weight: bold;
        cursor: pointer;
        position: absolute;
        top: 15px;
        right: 20px;
    }

        .close-modal:hover,
        .close-modal:focus {
            color: #000;
        }

    .modal-title {
        margin-top: 0;
        margin-bottom: 25px;
        text-align: center;
        color: #333;
        font-size: 24px;
    }

    .application-details {
        text-align: left;
    }

    .details-container {
        display: flex;
        gap: 20px;
        margin-bottom: 20px;
    }

    .details-column {
        flex: 1;
    }

    .detail-section {
        margin-bottom: 25px;
        padding: 15px;
        border-radius: 6px;
        background-color: rgba(13, 71, 161, 0.15);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
        border: 1px solid #eef2f7;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

        .detail-section:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.07);
        }

        .detail-section h3 {
            margin-top: 0;
            margin-bottom: 15px;
            color: #0d47a1;
            border-bottom: 1px solid #e0e6ef;
            padding-bottom: 8px;
        }

    .detail-row {
        display: flex;
        margin-bottom: 12px;
        padding-bottom: 12px;
        border-bottom: 1px solid #eef2f7;
    }

        .detail-row:last-child {
            margin-bottom: 0;
            padding-bottom: 0;
            border-bottom: none;
        }

    .label {
        font-weight: 500;
        color: #555;
        width: 120px;
        flex-shrink: 0;
    }

    .value {
        flex: 1;
        color: #333;
        word-break: break-word;
    }

    .form-group {
        margin-bottom: 20px;
    }

        .form-group label {
            display: block;
            margin-bottom: 8px;
            font-weight: 500;
            color: #555;
        }

    .status-select,
    .remarks-textarea {
        width: 100%;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 16px;
        box-sizing: border-box;
    }

        .status-select:focus,
        .remarks-textarea:focus {
            border-color: #409eff;
            outline: none;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        }

    .remarks-textarea {
        resize: vertical;
        min-height: 120px;
    }

    .form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 15px;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #e0e6ef;
    }

    .btn {
        padding: 10px 20px;
        border-radius: 4px;
        font-weight: 500;
        cursor: pointer;
        border: none;
        transition: background-color 0.3s;
    }

    .btn-primary {
        background-color: #409eff;
        color: white;
    }

        .btn-primary:hover:not(:disabled) {
            background-color: #66b1ff;
        }

        .btn-primary:disabled {
            background-color: #a0cfff;
            cursor: not-allowed;
        }

    .btn-secondary {
        background-color: #f0f7ff;
        color: #1a73e8;
        border: 1px solid #1a73e8;
    }

        .btn-secondary:hover {
            background-color: #e3f2fd;
        }

    .status-badge {
        display: inline-block;
        padding: 4px 10px;
        border-radius: 18px;
        font-size: 14px;
        font-weight: 500;
    }

        .status-badge.pending {
            background-color: #fff3cd;
            color: #856404;
        }

        .status-badge.contacted {
            background-color: #d1ecf1;
            color: #0c5460;
        }

        .status-badge.confirmed {
            background-color: #d4edda;
            color: #155724;
        }

        .status-badge.scheduled {
            background-color: #cce5ff;
            color: #004085;
        }

        .status-badge.rejected {
            background-color: #f8d7da;
            color: #721c24;
        }

        .status-badge.canceled {
            background-color: #e2e3e5;
            color: #383d41;
        }

    /* 响应式设计 */
    @media (max-width: 768px) {
        .details-container {
            flex-direction: column;
        }

        .modal-content {
            max-width: 95%;
            padding: 20px;
        }
    }
</style>